import { inject, Injectable } from '@angular/core';

import { TellentCurrentUserDataFacade } from '@core/tellent-logic';
import { SeatKind } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class AskHRService {
  private readonly currentUserDataService = inject(TellentCurrentUserDataFacade);

  public hasAskManageAbility = this.currentUserDataService.hasSeatAbility(
    SeatKind.CoreHR,
    'ask_manage',
  );

  public canAccessTicketsPage = this.hasAskManageAbility;
  public canAccessFormsPage = this.hasAskManageAbility;
}
